// source: witbooking/backoffice/propertymap/v1/propertymap_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.Coordinates', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.GeoLocation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.GeoMap', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.Location', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.MapCategory', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.MapTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.PropertyMap', null, global);
goog.exportSymbol('proto.witbooking.backoffice.propertymap.v1.TickerReference', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.displayName = 'proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.displayName = 'proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.displayName = 'proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.displayName = 'proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.displayName = 'proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.displayName = 'proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.MapTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.MapTranslation.displayName = 'proto.witbooking.backoffice.propertymap.v1.MapTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.propertymap.v1.PropertyMap.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.PropertyMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.PropertyMap.displayName = 'proto.witbooking.backoffice.propertymap.v1.PropertyMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.propertymap.v1.MapCategory.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.MapCategory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.MapCategory.displayName = 'proto.witbooking.backoffice.propertymap.v1.MapCategory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.propertymap.v1.GeoMap.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.GeoMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.GeoMap.displayName = 'proto.witbooking.backoffice.propertymap.v1.GeoMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.propertymap.v1.TickerReference.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.TickerReference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.TickerReference.displayName = 'proto.witbooking.backoffice.propertymap.v1.TickerReference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.Location.displayName = 'proto.witbooking.backoffice.propertymap.v1.Location';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.propertymap.v1.GeoLocation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.GeoLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.GeoLocation.displayName = 'proto.witbooking.backoffice.propertymap.v1.GeoLocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.propertymap.v1.Coordinates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.propertymap.v1.Coordinates.displayName = 'proto.witbooking.backoffice.propertymap.v1.Coordinates';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest;
  return proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertymap: (f = msg.getPropertymap()) && proto.witbooking.backoffice.propertymap.v1.PropertyMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse;
  return proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertymap.v1.PropertyMap;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.PropertyMap.deserializeBinaryFromReader);
      msg.setPropertymap(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertymap();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertymap.v1.PropertyMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional PropertyMap propertyMap = 1;
 * @return {?proto.witbooking.backoffice.propertymap.v1.PropertyMap}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.getPropertymap = function() {
  return /** @type{?proto.witbooking.backoffice.propertymap.v1.PropertyMap} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertymap.v1.PropertyMap, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertymap.v1.PropertyMap|undefined} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse} returns this
*/
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.setPropertymap = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.clearPropertymap = function() {
  return this.setPropertymap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.prototype.hasPropertymap = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertymap: (f = msg.getPropertymap()) && proto.witbooking.backoffice.propertymap.v1.PropertyMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest;
  return proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertymap.v1.PropertyMap;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.PropertyMap.deserializeBinaryFromReader);
      msg.setPropertymap(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertymap();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.propertymap.v1.PropertyMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional PropertyMap propertyMap = 1;
 * @return {?proto.witbooking.backoffice.propertymap.v1.PropertyMap}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.getPropertymap = function() {
  return /** @type{?proto.witbooking.backoffice.propertymap.v1.PropertyMap} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertymap.v1.PropertyMap, 1));
};


/**
 * @param {?proto.witbooking.backoffice.propertymap.v1.PropertyMap|undefined} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} returns this
*/
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.setPropertymap = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} returns this
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.clearPropertymap = function() {
  return this.setPropertymap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest.prototype.hasPropertymap = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse;
  return proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest;
  return proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse;
  return proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.MapTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.MapTranslation;
  return proto.witbooking.backoffice.propertymap.v1.MapTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.MapTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.PropertyMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    mapsList: jspb.Message.toObjectList(msg.getMapsList(),
    proto.witbooking.backoffice.propertymap.v1.GeoMap.toObject, includeInstance),
    categoriesList: jspb.Message.toObjectList(msg.getCategoriesList(),
    proto.witbooking.backoffice.propertymap.v1.MapCategory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.PropertyMap;
  return proto.witbooking.backoffice.propertymap.v1.PropertyMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.propertymap.v1.GeoMap;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.GeoMap.deserializeBinaryFromReader);
      msg.addMaps(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.propertymap.v1.MapCategory;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.MapCategory.deserializeBinaryFromReader);
      msg.addCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.PropertyMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.propertymap.v1.GeoMap.serializeBinaryToWriter
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.propertymap.v1.MapCategory.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GeoMap maps = 1;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.GeoMap>}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.getMapsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.GeoMap>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.GeoMap, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.GeoMap>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} returns this
*/
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.setMapsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoMap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.addMaps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.propertymap.v1.GeoMap, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.clearMapsList = function() {
  return this.setMapsList([]);
};


/**
 * repeated MapCategory categories = 2;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.MapCategory>}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.getCategoriesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.MapCategory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.MapCategory, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.MapCategory>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} returns this
*/
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.setCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapCategory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory}
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.addCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.propertymap.v1.MapCategory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.PropertyMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMap.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.MapCategory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapCategory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, ""),
    color: jspb.Message.getFieldWithDefault(msg, 4, ""),
    contrastText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mapTo: (f = msg.getMapTo()) && proto.witbooking.backoffice.propertymap.v1.TickerReference.toObject(includeInstance, f),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.propertymap.v1.MapTranslation.toObject, includeInstance),
    polygonColor: jspb.Message.getFieldWithDefault(msg, 8, ""),
    showIconPrice: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    icon: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.MapCategory;
  return proto.witbooking.backoffice.propertymap.v1.MapCategory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapCategory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContrastText(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.propertymap.v1.TickerReference;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.TickerReference.deserializeBinaryFromReader);
      msg.setMapTo(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.propertymap.v1.MapTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.MapTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPolygonColor(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowIconPrice(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.MapCategory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapCategory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContrastText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMapTo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.propertymap.v1.TickerReference.serializeBinaryToWriter
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.backoffice.propertymap.v1.MapTranslation.serializeBinaryToWriter
    );
  }
  f = message.getPolygonColor();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getShowIconPrice();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string color = 4;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contrast_text = 5;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getContrastText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setContrastText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional TickerReference map_to = 6;
 * @return {?proto.witbooking.backoffice.propertymap.v1.TickerReference}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getMapTo = function() {
  return /** @type{?proto.witbooking.backoffice.propertymap.v1.TickerReference} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertymap.v1.TickerReference, 6));
};


/**
 * @param {?proto.witbooking.backoffice.propertymap.v1.TickerReference|undefined} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
*/
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setMapTo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.clearMapTo = function() {
  return this.setMapTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.hasMapTo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated MapTranslation translations = 7;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.MapTranslation, 7));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
*/
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.backoffice.propertymap.v1.MapTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional string polygon_color = 8;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getPolygonColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setPolygonColor = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool show_icon_price = 9;
 * @return {boolean}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getShowIconPrice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setShowIconPrice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string icon = 10;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapCategory} returns this
 */
proto.witbooking.backoffice.propertymap.v1.MapCategory.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.GeoMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    proto.witbooking.backoffice.propertymap.v1.Location.toObject, includeInstance),
    googleMapsConfig: jspb.Message.getFieldWithDefault(msg, 3, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.propertymap.v1.MapTranslation.toObject, includeInstance),
    maptype: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.GeoMap;
  return proto.witbooking.backoffice.propertymap.v1.GeoMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.propertymap.v1.Location;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.Location.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGoogleMapsConfig(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.propertymap.v1.MapTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.MapTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaptype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.GeoMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.propertymap.v1.Location.serializeBinaryToWriter
    );
  }
  f = message.getGoogleMapsConfig();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.propertymap.v1.MapTranslation.serializeBinaryToWriter
    );
  }
  f = message.getMaptype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Location locations = 2;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.Location>}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.Location>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.Location, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.Location>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
*/
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.propertymap.v1.Location, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


/**
 * optional string google_maps_config = 3;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.getGoogleMapsConfig = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.setGoogleMapsConfig = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated MapTranslation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.MapTranslation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.MapTranslation>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
*/
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.MapTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.MapTranslation}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.propertymap.v1.MapTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional string mapType = 5;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.getMaptype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoMap} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoMap.prototype.setMaptype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.TickerReference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.TickerReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.TickerReference}
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.TickerReference;
  return proto.witbooking.backoffice.propertymap.v1.TickerReference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.TickerReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.TickerReference}
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.TickerReference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.TickerReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.TickerReference} returns this
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.TickerReference} returns this
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.TickerReference} returns this
 */
proto.witbooking.backoffice.propertymap.v1.TickerReference.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, ""),
    geo: (f = msg.getGeo()) && proto.witbooking.backoffice.propertymap.v1.GeoLocation.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location}
 */
proto.witbooking.backoffice.propertymap.v1.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.Location;
  return proto.witbooking.backoffice.propertymap.v1.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location}
 */
proto.witbooking.backoffice.propertymap.v1.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.propertymap.v1.GeoLocation;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.GeoLocation.deserializeBinaryFromReader);
      msg.setGeo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGeo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.propertymap.v1.GeoLocation.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string category = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GeoLocation geo = 2;
 * @return {?proto.witbooking.backoffice.propertymap.v1.GeoLocation}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.getGeo = function() {
  return /** @type{?proto.witbooking.backoffice.propertymap.v1.GeoLocation} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.propertymap.v1.GeoLocation, 2));
};


/**
 * @param {?proto.witbooking.backoffice.propertymap.v1.GeoLocation|undefined} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location} returns this
*/
proto.witbooking.backoffice.propertymap.v1.Location.prototype.setGeo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.clearGeo = function() {
  return this.setGeo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.hasGeo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Location} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Location.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.GeoLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.witbooking.backoffice.propertymap.v1.Coordinates.toObject, includeInstance),
    positionIconList: jspb.Message.toObjectList(msg.getPositionIconList(),
    proto.witbooking.backoffice.propertymap.v1.Coordinates.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.GeoLocation;
  return proto.witbooking.backoffice.propertymap.v1.GeoLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.propertymap.v1.Coordinates;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.Coordinates.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.propertymap.v1.Coordinates;
      reader.readMessage(value,proto.witbooking.backoffice.propertymap.v1.Coordinates.deserializeBinaryFromReader);
      msg.addPositionIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.GeoLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.propertymap.v1.Coordinates.serializeBinaryToWriter
    );
  }
  f = message.getPositionIconList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.propertymap.v1.Coordinates.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Coordinates values = 2;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.Coordinates, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} returns this
*/
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.Coordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.propertymap.v1.Coordinates, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * repeated Coordinates position_icon = 3;
 * @return {!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.getPositionIconList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.propertymap.v1.Coordinates, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.propertymap.v1.Coordinates>} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} returns this
*/
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.setPositionIconList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.Coordinates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates}
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.addPositionIcon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.propertymap.v1.Coordinates, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.propertymap.v1.GeoLocation} returns this
 */
proto.witbooking.backoffice.propertymap.v1.GeoLocation.prototype.clearPositionIconList = function() {
  return this.setPositionIconList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.propertymap.v1.Coordinates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.propertymap.v1.Coordinates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.toObject = function(includeInstance, msg) {
  var f, obj = {
    lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    lng: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    order: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.propertymap.v1.Coordinates;
  return proto.witbooking.backoffice.propertymap.v1.Coordinates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.propertymap.v1.Coordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLng(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.propertymap.v1.Coordinates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.propertymap.v1.Coordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.getLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.setLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lng = 2;
 * @return {number}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.getLng = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.setLng = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 order = 3;
 * @return {number}
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.propertymap.v1.Coordinates} returns this
 */
proto.witbooking.backoffice.propertymap.v1.Coordinates.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.propertymap.v1);
